<template>
  <div id="app">
    <!--    遮罩层-->
    <!-- <div class="MARKUP-XYJ"
         @click="hideMarkup"
    ></div>
    <locationNav></locationNav> -->
    <router-view />
  </div>
</template>

<script>
// import locationNav from "@/components/appComponents/locationNav.vue";
import Cookies from "js-cookie";
export default {
  name: "App",
  // components: {
  //   locationNav
  // },
  data() {
    return {
      isShowMarkup: false,
      payloadMessageObj: {},
      topiclist:[]
    };
  },
  mounted() {
    if (sessionStorage.getItem("userid") && sessionStorage.getItem("branchId")) {
      // 有的话证明登录进去了
      // 获取站内消息主题并订阅
      this.findMsgTopic();
    }
    const _this = this;
    // _this.$data._XYJ_CaseOnly_Id
    window.addEventListener("setItem", (e) => {
      // 获取站内消息主题并订阅
      _this.findMsgTopic();
      if (sessionStorage.getItem("branchId") == 1) {
        // 总公司订阅账号是否被强制退出消息
        _this.$mqtt.subscribe(123456, sessionStorage.getItem("userid"), {
          messageArrived: _this.MessageArrived,
          messageDelivered: _this.MessageDelivered
        });
      } else {
        // 子公司订阅账号是否被强制退出消息
        _this.$mqtt.subscribe(123456, sessionStorage.getItem("userid"), {
          messageArrived: _this.MessageArrived,
          messageDelivered: _this.MessageDelivered
        });
        _this.$mqtt.subscribe(123456, sessionStorage.getItem("branchId"), {
          messageArrived: _this.MessageArrived,
          messageDelivered: _this.MessageDelivered
        });
      }
    });
  },
  methods: {
    MessageArrived: function(payloadMessage) {
      const payloadString = JSON.parse(payloadMessage.payloadString);
      if (!payloadString) {
        this.$alert("该账号被禁用将强制退出登录", "警告", {
          confirmButtonText: "确定",
          callback: action => {
            sessionStorage.removeItem("user");
            sessionStorage.removeItem("userid");
            this.$mqtt.clearSubScribe(123456);
            Cookies.remove("token");
            // 清除tab标签页
            this.$store.commit("updateMainTabs", []);
            if (sessionStorage.getItem("branchCode") !== "1") {
              this.$router.push("/CLogin");
            } else {
              this.$router.push("/Login");
            }
            this.$api.login.logout().then((res) => {
              if (sessionStorage.getItem("branchCode") !== "1") {
                this.$router.push("/CLogin");
              } else {
                this.$router.push("/Login");
              }
            }).catch(function(res) {
            });
          }
        });
      }
    },
    MessageDelivered: function(message) {
      const payloadString = JSON.parse(payloadMessage.payloadString);
    },
    hideMarkup() {
      this.jquery(".MARKUP-XYJ").removeClass("showMarkupXYJ");
      this.jquery(".groupFloat").removeClass("groupFloat");
    },
    // 获取站内消息主题
    findMsgTopic() {
      this.axios({
        url: this.zuul + "/xyj-admin/r/sysInstationMsg/findMsgTopic",
        method: "post",
        params: {
        	branchId: sessionStorage.getItem("branchId"),
          userId: sessionStorage.getItem("userid")
        }
      }).then(res => {
        this.topiclist = res.data;
        res.data.forEach(item => {
          this.$mqtt.subscribe(this.$data._XYJ_CaseOnly_Id, item, {
            messageArrived: this.MessageArrivedMsg,
            messageDelivered: this.MessageDeliveredMsg
          });
        });
      }).catch(err => {
        this.$message.error(err.message);
      });
    },
    MessageArrivedMsg: function(payloadMessage) {
      const payloadString = JSON.parse(payloadMessage.payloadString);
      this.payloadMessageObj = payloadString;
      this.showNotify(payloadString);
    },
    MessageDeliveredMsg: function(message) {
      const payloadString = JSON.parse(message.payloadString);
      this.showNotify(payloadString);
    },
    // 显示通知
    showNotify(item) {
      const _this = this;
      this.$notify({
        title: item.msgName,
        type: item.hintType == 0 ? "info" : item.hintType == 1 ? "warning" : "info",
        dangerouslyUseHTMLString: true,
        message: this.$createElement(
          'div',
          {},
          [
            this.$createElement('p', {}, [
              this.$createElement('span', { on: { click: function(){
                if(item.menuRoute){_this.handleClick(item)}
              } } }, item.sendMsg),
              // this.$createElement('a',
              //   {
              //     class: 'send-elink-btn',
              //     on: { click: this.test }
              //   }, '点击调用test函数'),
              // this.$createElement('a',
              //   {
              //     class: 'send-elink-btn',
              //     on: { click: () => {this.test('222')} }
              //   }, '点击调用test函数带参数'),
            ]),
          ]
        ),
      });
    },
    // 获取路由信息
    getRoute(name) {
      return new Promise((resp, rej) => {
      	this.axios({
          url: this.zuul + "/xyj-admin/r/sysMenuRoute/query",
          method: "post",
          data: {
          	pageBean: {
            	page: 1,
              pageSize: 10,
              showTotal: true,
              summary: []
            },
            params: {},
            querys: [
            	{ hasInitValue: false, operation: "EQUAL", property: "menuRoute", relation: "AND", value: name }
            ],
            selfDate: {},
            sorter: []
          }
        }).then(res => {
          resp(res.data.rows[0].touteChineseName);
        }).catch(err => {
          this.$message.error(err.message);
          resp(true);
        });
      });
    },
    // 跳转页面
    handleClick(item) {
      this.readMsg(item);
      this.getRoute(item.menuRoute).then(res => {
        this.$api.component.XyjPcRoutesPush(this, { componentName: item.menuRoute, loadPath: item.menuRoute, chinesename: res }).then((res) => {
          this.$router.push({
            path: "/" + item.menuRoute,
            params: {
              msgParam: item.businessJson
            }
          });
        }).catch((error) => {
          this.$router.push({
            path: "/" + item.menuRoute,
            params: { msgParam: item.businessJson }
          });
        });
      });
    },
    // 读消息
    readMsg(item) {
      this.axios({
        url: this.zuul + "/xyj-admin/w/sysInstationMsgRecord/readMsg",
        method: "get",
        params: { id: item.id }
      }).then(res => {

      }).catch(err => {
        this.$message.error(err.message);
      });
    }
  }
};
</script>

<style lang="scss">
@import "https://at.alicdn.com/t/font_2528448_xajuzz4anir.css";
// @import "https://at.alicdn.com/t/c/font_4444265_ky9lzipqaj.css";
@import "./assets/css/iconfont.css";
@import "./css/common.scss";
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #484a4d;
  /* background:  #b6bbbb21; */
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  overflow: auto;
}
.header{
  padding: 0!important;
}
.dialog-lunbo-uploader .el-upload{
    width: 100%;
    position: relative;
    display: flex;
}
.el-message__content{
  white-space: pre-line;
}
::-webkit-scrollbar{
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-thumb{
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #e6e8ec;
}
::-webkit-scrollbar-track{
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #f5f5f5;
}
.el-button--danger{
	color:#fff!important;
	background-color: red!important;
  border-color: red!important;
}
.el-button--danger:hover{
	color:#fff!important;
	background-color: red!important;
  border-color: red!important;
}
.el-button--danger:focus{
	color: #fff!important;
	background-color: red!important;
  border-color: red!important;
}
.el-button--danger.is-disabled{
  background-color: #fab6b6!important;
  border-color: #fab6b6!important;
}
/*
  遮罩层
*/
.MARKUP-XYJ{
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: -100;
  width: 100%;
  height: 100%;
  opacity: 0;
  background: rgba(0,0,0,.3);
  transition: all .3s ease;
  -webkit-transition: all .3s ease;
}
/*
  隐藏遮罩层
*/
.showMarkupXYJ{
  opacity: 1!important;
  z-index:3000!important;
}
/*
  当有浮层的时候需要让其的bottom为0，那么就加上这个css
*/
  .groupFloat{
    bottom: 0!important;
  }
  #searchDialog{
		text-align:center!important
	}
  #Physicalfitnessmonitoring {
    height: 100%;
    .content{
      background-color: #111E4E;
      box-sizing: border-box;
      padding: 15px 20px;
      height: 100%;
      color: #ffffff;
    }
    .nav{
      position: relative;
      display: flex;
      height: 80px;
      background-color: #111E4E;
    }
    /* 左侧区域样式 */
    .nav-left{
      text-align: left;
      width: 25%;
      box-sizing: border-box;
      position: absolute;
      top: 15px;
      left: 0;
    }
    .nav-left .tab:first-child{
      margin-right: 10px;
    }
    /* 列表卡样式 */
    .tab{
      width: 40%;
      box-sizing: border-box;
      border: 1px solid #53B9D7;
      border-radius: 4px;
      padding: 5px 20px;
      display: inline-block;
      background-color: #182F61;
      color: #ACBFDC;
      text-align:center;
    }
    .tab>span{
      display: block;
      color: #ACBFDC;
    }
    .tab>span:first-child{
      font-size: 12px;
      margin-bottom: 10px;
    }
    .tab>span:last-child{
      font-weight: 700;
    }
    /* 斜线样式 */
    .line1,.line2,.line3{
      box-sizing: border-box;
      height: 70px;
      border: 0;
      background: #111E4E;
    }
    .line1{
      flex: 1;
      transform: skew(20deg);
      border-top: 2px solid #00A8F1;
      border-right: 2px solid #00A8F1;
      border-image: linear-gradient(to right, #093F62, #00A8F1) 1 10;
    }
    .line2{
      flex: 2;
      border-bottom: 2px solid #00A8F1;
    }
    .line3{
      flex: 1;
      transform: skew(-20deg);
      border-top: 2px solid #00A8F1;
      border-left: 2px solid #00A8F1;
      border-image: linear-gradient(to left, #093F62, #00A8F1) 1 10;
    }
    .timeline{
      position: absolute;
      bottom: 9px;
      left: 50%;
      margin-left: -50px;
      width: 100px;
      height: 0;
      border: 2px solid #00C3FF;
    }
    /* 中间标题区域样式 */
    .nav-center{
      position: absolute;
      left: 30%;
      width: 40%;
      box-sizing: border-box;
    }
    .center{
      height: 69px;
      line-height: 69px;
      font-size: 22px;
      font-weight: 600;
    }
    .center>img{
      width: 40px;
      height: 40px;
      vertical-align: middle;
    }
    /* 左侧区域样式 */
    .nav-right{
      width: 25%;
      box-sizing: border-box;
      position: absolute;
      top: 15px;
      right: 0;
    }
    .nav-right .tab:first-child{
      margin-right: 10px;
    }
    /* 图表区域样式 */
    .echartsList{
      display: flex;
      height: 40%;
    }
    /* 表格样式修改 */
    /deep/ .el-table,.el-table /deep/ .el-table__row{
      background-color: #071E52!important;
      color: #AFBCCF!important;
    }
    .el-table /deep/ td,.el-table /deep/ th{
      border: none!important;
    }
    .el-table /deep/ .warning-row{
      background:#003C6F!important;
    }
    /* 中间图表样式 */
    .title{
      font-size: 14px;
      color: #ACBFDC;
      text-align: left;
    }
    .title i{
      display: inline-block;
      width: 8px;
      height: 20px;
      background-color: #ED0000;
      vertical-align: middle;
      margin-right: 15px;
    }
    .footer{
      height:4%;
      display:flex;
      justify-content: center;
      align-items: center;
      border-top: 1px solid #15396F;
    }
    .footer>div:first-child{
      margin-right: 50px;
    }
    .footer>div>img{
      height: 20px;
      vertical-align: bottom;
      margin-right: 15px;
    }
    .echartsList /deep/.el-table--enable-row-hover .el-table__body tr:hover > td ,/deep/ .el-button--mini{
      background-color: transparent!important;
    }
    /deep/ .el-table__footer-wrapper tbody td, .el-table__header-wrapper tbody td,
    /deep/ .el-table__fixed-footer-wrapper tbody td,
    /deep/ .el-table__fixed-right::before, .el-table__fixed::before{
      background-color: #071E52;
    }
    /deep/ .el-data-table .serach-style .el-form-item .el-form-item__content>div input,
    /deep/ .el-pagination .el-select .el-input .el-input__inner,
    /deep/ .el-pagination__editor.el-input .el-input__inner,
    /deep/ .el-pager li.active,
    /deep/ .el-pagination button:disabled{
      background-color: #264384;
      color: #fff;
      border-color: #316776;
    }
    /deep/ .el-table--border{border-color: #316776;}
    /deep/ .el-data-table .serach-style>div>div>div label,
    /deep/ .el-pagination button, .el-pagination span:not([class*=suffix]){
      color: #fff;
    }
    .el-table::before{
      background-color: transparent;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue